<template>
  <div class="tip_box"  @touchmove.prevent='cancelSelect'  v-show="showBox1">
    <!-- 部门处理时间轴弹窗 -->
    <div class="box">
      <div class="content">
        <div class="title1">部门处理时间轴</div>
        <better-scroll1 class="content_box" :scrollY="true" ref="content">
          <div class="content_line">
            <div class="item" v-for="(item,i) in timeList" :key="i">
              <span class="col"></span>
              <div class="item_title1">{{item.operateTypeValue}}</div>
              <div class="text_content">
                <p class="tip1">{{item.createTime}}</p>
                <div class="tip2">
                  <span class="text_content_spa">{{item.operateOrgName}}</span>
                </div>

                <div class="tip2">
                  <span class="text_content_spa">{{item.operateUserName}}</span>
                </div>
                <div class="tip2" v-if="item.operateType===1060">
                  <div class="score" v-for="(item1,index1) in item.evaluation" :key="index1">
                    <i>{{item1.feedbackOrg_name}} ：</i>
                    <img src="../../../../assets/image/happy.png" v-if="item1.score===3"/><img src="../../../../assets/image/norCopy.png" v-if="item1.score===2"/>
                    <img src="../../../../assets/image/unhappy.png" v-if="item1.score===1"/>
                    <i v-if="item1.score===3">满意</i>
                    <i v-if="item1.score===2">基本满意</i>
                    <i v-if="item1.score===1">不满意</i>
                  </div>
                  <div class="remark">{{item.operateContent}}</div>
                </div>
                <div class="tip2" v-if="item.operateType!=1060">
                  <span class="text_content_spa">{{item.operateContent}}</span>
                </div>
                <div class="imgList">
                  <img :src="i" alt  v-for="(i,idx) in item.url" :key="idx" @click="showViewer(idx, $event,item.url)" />
                </div>
              </div>
            </div>
          </div>
        </better-scroll1>
      </div>
      <img src="../../../../assets/complaint/icon_close.png" class="close" @click="hideBox" />
    </div>
  </div>
</template>
<script>
    import betterScroll from '../../../../components/base/betterScroll';
    export default {
        components: {
            'better-scroll1': betterScroll
        },
        data () {
            return {
                hideBox1: false
            };
        },
        props: ['showBox1', 'timeList'],
        created () {
            // setTimeout(() => {
            //     this.$refs.content.refresh();
            // }, 50)
        },
        methods: {
            // beforeRouteLeave (to, from, next) {
            //     this.showImages.close();
            //     next();
            // },
            cancelSelect () {},
            hideBox () {
                this.$emit('setHideBox');
            },
            // 图片预览
            showViewer (index, event, imgList) {
                this.$emit('setHideBox');
                this.$router.push({
                  path: '/complaint/imagesView',
                  query: {
                    imageList:imgList|| [],
                    index
                  },
                })

                // this.$ImagePreview({ images: imgList, startPosition: index, closeOnPopstate: true });
            }
        }

    };
</script>
<style lang="less" scoped>
.tip_box {
  width: 100%;
  height:100vh;
  position: fixed;
  left:0;
  top:0;
  z-index: 99999999999;
  background-color: rgba(0,0,0,.5);
  .box {
    width:90%;
    height:70%;
    position: relative;
    left:50%;
    top:50%;
    transform: translate(-50%,-50%);
    .content {
      width: 100%;
      height: 100%;
      background: #fff;
      border-radius: 6px;
      .title1 {
        text-align: center;
        height: 58px;
        font-size: 16px;
        color: #666;
        line-height: 58px;
      }
      .content_box {
        height: 82%;
        padding: 22px 18px 0 18px;
        box-sizing: border-box;
        z-index: 999999999;
        .content_line {
          margin-top: 10px;
          padding: 20px;
          width: 100%;
          overflow: hidden;
          .item {
            width: 100%;
            position: relative;
            border-left: 1px solid #efefef;
            .col {
              position: absolute;
              left: -7px;
              top: -6px;
              width: 12px;
              height: 12px;
              background-color: #fff;
              border-radius: 50%;
              border: 1px solid #36b374;
            }
            .item_title1 {
              width: 100%;
              position: absolute;
              left: 17px;
              top: -5px;
              color: #333;
              font-size: 14px;
              font-weight: 700;
            }
            .text_content {
              margin-left: 18px;
              padding-top: 22px;
              padding-bottom: 20px;
              width: 98%;
              .tip1 {
                font-size: 12px;
                color: #333;
                margin: -2px 0;
              }
              .text_content_spa {
                line-height: 22px;
                overflow: hidden;
              }
              .tip2 {
                margin-top: 12px;
                span {
                  font-size: 14px;
                }
                span:nth-child(1) {
                  color: #9b9b9b;
                }
                span:nth-child(2) {
                  color: #9b9b9b;
                }
                .orige{
                  font-size:14px;
                  color:#9b9b9b;
                }
                .score{
                  margin-top:10px;
                  i{
                    display: inline-block;
                    font-size:14px;
                    color:#9b9b9b;
                    vertical-align: middle;
                  }
                  img{
                    display: inline-block;
                    width:15px;
                    height:15px;
                    vertical-align: middle;
                    margin-left:10px;

                  }
                }
                .remark{
                  margin-top:10px;
                  font-size:14px;
                  color:#9b9b9b;
                }

              }
              .imgList {
                overflow: hidden;
                img {
                  margin-top: 10px;
                  float: left;
                  width: 70px;
                  height: 70px;
                  display: block;
                  margin-right: 10px;
                  border-radius: 3px;
                }
              }
              .about_text {
                font-size: 14px;
                color: #333333;
                line-height: 1.4em;
                margin-top: 12px;
              }
            }
          }
          .item:last-child {
            border: none;
          }
        }
      }
    }
    .close {
      width: 44px;
      height: 44px;
      position: absolute;
      left: 50%;
      margin-left: -22px;
      bottom: -52px;
    }
  }
}
</style>